import {Currency} from "./currency";
import {PaymentMethod} from "./Checkout/PaymentMethod";
import {ShippingMethod} from "./Checkout/ShippingMethod";
import {CartItem} from "./cartItem";
import {CartExtensionAttribute} from "./cartExtensionAttribute";
import {Customer} from "../user";
import {BillingAddress} from "./billingAddress";
import {CustomerAddress} from "../CustomerInfo/CustomerAddress";

export class Cart {
    billingAddress : BillingAddress;
    createdAt : string
    currency : Currency
    customer : Customer
    customerIsGuest : boolean
    customerNoteNotify : boolean
    customerTaxClassId : number
    extensionAttributes : CartExtensionAttribute
    id :number
    isActive : boolean
    isVirtual : boolean
    items : CartItem[] = [];
    itemsCount : number
    itemsQty : number
    origOrderId : number
    storeId : number
    updatedAt : string
    cartType: string
    quoteId: string
    selectedAddress: CustomerAddress
    selectedShippingmethod: ShippingMethod
    selectedPaymentMethod: PaymentMethod
    availableShippingmethods: [ShippingMethod]

    orderRestrictions: any;


}
